import React, { useState, useEffect } from 'react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Проверяем, давал ли пользователь согласие ранее
    const consentGiven = localStorage.getItem('cookieConsent');
    if (!consentGiven) {
      // Показываем баннер через небольшую задержку для плавности
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
    // Здесь можно добавить логику активации аналитики, если нужно
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
    // Здесь можно отключить скрипты аналитики
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6">
      <div className="mx-auto max-w-7xl">
        <div className="rounded-2xl bg-white shadow-2xl border border-gray-100 p-6 md:p-8">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                🍪 Политика использования cookie
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Продолжая использовать сайт, вы даете согласие на обработку cookie-файлов согласно{' '}
                <a 
                  href="/privacy" 
                  className="text-blue-600 hover:text-blue-800 underline transition-colors"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Политике обработки персональных данных
                </a>. 
                Если вы не хотите, чтобы данные обрабатывались, просим отключить обработку в настройках вашего браузера. 
                Вы вправе изменить выбор в любой момент.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <button
                onClick={handleDecline}
                className="px-6 py-3 text-sm font-medium text-gray-700 bg-gray-100 rounded-xl hover:bg-gray-200 transition-all duration-200 focus:ring-2 focus:ring-gray-400 focus:outline-none"
              >
                Отказаться
              </button>
              <button
                onClick={handleAccept}
                className="px-6 py-3 text-sm font-medium text-white bg-[#009EE3] rounded-xl hover:bg-[#009EE3]/60 transition-all duration-200 focus:ring-2 focus:ring-blue-300 focus:outline-none shadow-lg shadow-blue-600/20"
              >
                Принять
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;